import breakpoints from '@/scripts/utils/_breakpoints';
import 'select2';
import 'select2/dist/css/select2.min.css';

const getPlaceholder = el => (window.innerWidth > breakpoints.lg ? el.dataset.placeholder : '');

export default function initCustomSelect(el) {
  // ugly fix for select toggle animation
  const duration = document.documentElement.dataset.duration * 1000;
  $(el).on('select2:open', function () { // eslint-disable-line func-names
    const $dropdown = $(this).closest('.input-block').find('.select2-dropdown').addClass('opening');
    $dropdown.addClass('opening');
    setTimeout(() => $dropdown.addClass('opened'), duration);
  });
  $(el).on('select2:closing', function (e) { // eslint-disable-line func-names
    if (!$(el).data('closing')) {
      e.preventDefault();
      $(el).data('closing', true);
      $(this).closest('.input-block').find('.select2-dropdown').removeClass('opening opened');
      setTimeout(() => $(el).select2('close'), duration);
    }
  });
  $(el).on('select2:close', () => {
    if ($(el).data('closing')) $(el).data('closing', false);
  });

  // end ugly fix for select toggle animation

  return $(el).select2({
    dropdownParent: $(el).closest('.input-block__input'),
    placeholder: getPlaceholder(el),
    minimumResultsForSearch: Infinity,
  });
}



// WEBPACK FOOTER //
// ./scripts/utils/initCustomSelect.js